<template>
  <a-modal class="nodeImageDialog" title="图片" :visible="dialogVisible" width="40%">
    <ImgUpload ref="ImgUpload" v-model="img" style="margin-bottom: 12px" />
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </a-modal>
</template>

<script>
import ImgUpload from '../ImgUpload';
import { getImageSize, isMobile } from 'simple-mind-map/src/utils/index';

export default {
  name: 'NodeImage',
  components: {
    ImgUpload
  },
  data() {
    return {
      dialogVisible: false,
      img: '',
      imgUrl: '',
      imgTitle: '',
      activeNodes: null,
      isMobile: isMobile()
    };
  },
  created() {
    this.$bus.$on('node_active', this.handleNodeActive);
    this.$bus.$on('showNodeImage', this.handleShowNodeImage);
  },
  beforeDestroy() {
    this.$bus.$off('node_active', this.handleNodeActive);
    this.$bus.$off('showNodeImage', this.handleShowNodeImage);
  },
  methods: {
    handleNodeActive(...args) {
      this.activeNodes = [...args[1]];
    },

    handleShowNodeImage() {
      this.reset();
      if (this.activeNodes.length > 0) {
        const firstNode = this.activeNodes[0];
        const img = firstNode.getData('image') || '';
        if (img) {
          if (/^https?:\/\//.test(img)) {
            this.imgUrl = img;
          } else {
            this.img = img;
          }
        }
        this.imgTitle = firstNode.getData('imageTitle') || '';
      }
      this.dialogVisible = true;
    },

    cancel() {
      this.dialogVisible = false;
      this.reset();
    },

    reset() {
      this.img = '';
      this.imgTitle = '';
      this.imgUrl = '';
    },

    async confirm() {
      try {
        // 删除图片
        if (!this.img && !this.imgUrl) {
          this.cancel();
          this.activeNodes.forEach(node => {
            node.setImage(null);
          });
          return;
        }
        let res = null;
        let img = '';
        if (this.img) {
          img = this.img;
          res = await this.$refs.ImgUpload.getSize();
        } else if (this.imgUrl) {
          img = this.imgUrl;
          res = await getImageSize(img);
        }
        this.activeNodes.forEach(node => {
          node.setImage({
            url: img || 'none',
            title: this.imgTitle,
            width: res.width || 100,
            height: res.height || 100
          });
        });
        this.cancel();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.nodeImageDialog {
  .title {
    font-size: 18px;
    margin-bottom: 12px;
  }

  .inputBox {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .label {
      width: 150px;
    }
  }
}
</style>
